import { render, staticRenderFns } from "./TrashBox.vue?vue&type=template&id=fdc33fc8&"
import script from "./TrashBox.vue?vue&type=script&lang=js&"
export * from "./TrashBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\dev\\www\\aliventa\\gruene-hex\\admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fdc33fc8')) {
      api.createRecord('fdc33fc8', component.options)
    } else {
      api.reload('fdc33fc8', component.options)
    }
    module.hot.accept("./TrashBox.vue?vue&type=template&id=fdc33fc8&", function () {
      api.rerender('fdc33fc8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Modals/TrashBox.vue"
export default component.exports